import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import styles from '../css/Navbar.module.css';

const Navbar = ({ user, onLogout, setIsModalOpen }) => {
    const [scrolled, setScrolled] = useState(false);
    const [isHistoryOpen, setIsHistoryOpen] = useState(false);
    const [isMenuOpen, setIsMenuOpen] = useState(false); // Nuevo estado para la hamburguesa
    const location = useLocation();
    const navigate = useNavigate();

    // 1. DEFINICIÓN DE RUTAS (Para evitar errores de "not defined")
    const isAdminPath = location.pathname.startsWith('/panel');
    const isHomePath = location.pathname === '/';
    const isHistoriaPath = location.pathname === '/historia-iglesia';
    const isFePath = location.pathname === '/declaracion-fe';
    const isCorporacionPath = location.pathname === '/historia-corporacion';
    const isRecuerdosPath = location.pathname === '/del-recuerdo';

    // Detectamos si hay un álbum abierto (?album=...)
    const params = new URLSearchParams(location.search);
    const hasAlbumOpen = params.has('album');

    // 2. EFECTO DE SCROLL
    useEffect(() => {
        const handleScroll = () => setScrolled(window.scrollY > 50);
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    // Cerrar menú al cambiar de ruta
    useEffect(() => {
        setIsMenuOpen(false);
        setIsHistoryOpen(false);
    }, [location]);

    // 3. LÓGICA DE TRANSPARENCIA INTELIGENTE
    // Se vuelve sólido si: scroll, admin, menú abierto o ruta sin Hero
    const shouldBeSolid = scrolled || isAdminPath || isMenuOpen || (!isHomePath && !isHistoriaPath && !isFePath && !isCorporacionPath && !isRecuerdosPath);

    return (
        <nav className={`${styles.navbar} ${shouldBeSolid ? styles.navbarScrolled : ''} ${isAdminPath ? styles.navAdmin : ''}`}>
            
            {/* LOGO DINÁMICO */}
            <Link to="/" className={`${styles.navLogo} ${shouldBeSolid ? styles.logoScrolled : ''}`}>
                <img src="/Logo-Iump-Concon.ico" alt="Logo" />
                <span className={shouldBeSolid ? styles.logoOnly : ''}>IUMP CONCÓN</span>
            </Link>

            {/* BOTÓN HAMBURGUESA (Solo visible en CSS para móviles) */}
            <button 
                className={styles.mobileMenuBtn} 
                onClick={() => setIsMenuOpen(!isMenuOpen)}
                aria-label="Menu"
            >
                <i className={isMenuOpen ? 'fas fa-times' : 'fas fa-bars'}></i>
            </button>

            {/* Se añade la clase dinámica para mostrar/ocultar el menú en móviles */}
            <ul className={`${styles.navLinks} ${isMenuOpen ? styles.navLinksActive : ''}`}>

                    <>
                        <li>
                            {hasAlbumOpen ? (
                                <button onClick={() => navigate('/galeria')} className={styles.navBtnNav}>
                                    <i className="fas fa-arrow-left"></i> Atrás
                                </button>
                            ) : (
                                <Link to="/" className={styles.navBtnNav}>Inicio</Link>
                            )}
                        </li>

                        {location.pathname !== '/galeria' && <li><Link to="/galeria">Galería</Link></li>}
                        {location.pathname !== '/del-recuerdo' && <li><Link to="/del-recuerdo">Recuerdos</Link></li>}
                        
                        {/* Dropdown Historia */}
                        <li className={`${styles.navDropdownContainer} ${styles.hideOnMobile}`}
                            onMouseEnter={() => setIsHistoryOpen(true)}
                            onMouseLeave={() => setIsHistoryOpen(false)}
                        >
                            <span className={styles.navDropdownTitle}>
                                Historia <i className={`fas fa-chevron-down ${styles.arrowIcon}`}></i>
                            </span>
                            
                            {/* Quitamos el corto circuito para que CSS maneje la visibilidad */}
                            <ul className={`${styles.navDropdownMenu} ${isHistoryOpen ? styles.showMobileDropdown : ''}`}>
                                <li>
                                    <Link to="/historia-iglesia" className={styles.dropdownItem}>
                                        <div className={styles.dropdownIcon}><i className="fas fa-church"></i></div>
                                        <div className={styles.dropdownText}>
                                            <div className={styles.dropdownTitle}>Nuestra Iglesia</div>
                                            <div className={styles.dropdownSubtext}>Orígenes en Concón.</div>
                                        </div>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/declaracion-fe" className={styles.dropdownItem}>
                                        <div className={styles.dropdownIcon}><i className="fas fa-scroll"></i></div>
                                        <div className={styles.dropdownText}>
                                            <div className={styles.dropdownTitle}>Declaración de Fe</div>
                                            <div className={styles.dropdownSubtext}>Nuestra doctrina.</div>
                                        </div>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/historia-corporacion" className={styles.dropdownItem}>
                                        <div className={styles.dropdownIcon}><i className="fas fa-landmark"></i></div>
                                        <div className={styles.dropdownText}>
                                            <div className={styles.dropdownTitle}>Corporación</div>
                                            <div className={styles.dropdownSubtext}>Historia nacional.</div>
                                        </div>
                                    </Link>
                                </li>
                            </ul>
                        </li>

                        {/* VERSION 2: MÓVIL (Solo se ve en celulares) */}
                        <li className={`${styles.navDropdownContainerMobile} ${styles.hideOnDesktop}`}
                            onClick={() => setIsHistoryOpen(!isHistoryOpen)}
                        >
                            <div className={styles.mobileDropdownToggle}>
                                HISTORIA <i className={`fas fa-chevron-down ${isHistoryOpen ? styles.arrowRotate : ''}`}></i>
                            </div>
                            
                            <ul className={`${styles.mobileSubMenu} ${isHistoryOpen ? styles.showMobileSub : ''}`}>
                                <li><Link to="/historia-iglesia">Nuestra Iglesia</Link></li>
                                <li><Link to="/declaracion-fe">Declaración de Fe</Link></li>
                                <li><Link to="/historia-corporacion">Corporación</Link></li>
                            </ul>
                        </li>

                        <li>
                            <button onClick={() => setIsModalOpen(true)} className={styles.navBtnNav}>
                                <i className="fas fa-bell"></i> Avisos
                            </button>
                        </li>
                        {user && <li><Link to="/panel" className={styles.adminLinkBadge}>Panel</Link></li>}
                    </>
             
            </ul>
        </nav>
    );
};

export default Navbar;